define('models/base/sync-collection',['require','underscore','chaplin','models/base/collection'],function(require) {
    'use strict';

    var _ = require('underscore'),
        Chaplin = require('chaplin'),
        Collection = require('models/base/collection');

    var SyncCollection = Collection.extend({
        initialize: function() {
            Collection.prototype.initialize.apply(this, arguments);
            _.extend(this, Chaplin.SyncMachine);
        }
    });

    return SyncCollection;
});
